const { getUrlParam, log } = require('./helpers');

const redirectUrlParamName = 'r';

function redirect(url) {
    log('REDIRECT', url);
    // Using setTimeout here to put redirect at the end of the event loop.  Might be some tracking
    // reactions or cleanup that need to run before we navigate.
    setTimeout(() => {
        window.location.href = url || window.location.href;
    }, 10);
}

function getRedirectUrl(sourceUrl) {
    let redirectUrl = getUrlParam(redirectUrlParamName, sourceUrl);

    const redirectUrlData = new URL(redirectUrl, window.location.href);

    // Make sure that we're going to the path within the app
    if (redirectUrlData.host !== window.location.host) {
        log('Redirect url refers to different host! Setting redirect url to the root of app.')

        redirectUrl = '/';
    }

    return redirectUrl;
}

module.exports = {
    redirect,
    getRedirectUrl
};